<template>
  <div class="container">
    <div class="content">
      <img src="https://xnr-file.oss-cn-beijing.aliyuncs.com/xnd_wx/register_bg.jpg" alt="" class="bg">
      <div class="logobox">
        <img src="https://xnr-file.oss-cn-beijing.aliyuncs.com/xnd_wx/register_logo.png" alt="" class="logo">
        <p class="title">兴农达管理平台体验版</p>
      </div>
      <div class="box">
        <p class="tx">注册体验账号</p>
        <van-form @submit="onSubmit" :show-error="false">
          <van-field v-model="name" name="name" label="姓名" placeholder="请输入您的姓名"
            :rules="[{ required: true, message: '请输入您的姓名' }]" />
          <van-field v-model="tel" center clearable type="tel" maxlength="11" name="pattern" label="手机号"
            placeholder="请输入您的手机号" :rules="[{  pattern, message: '手机号格式错误' }]">
            <template #button v-if="verification">
              <span class="codetx" @click="sendCode">{{codeTx}}</span>
            </template>
            <template #button v-else>
              <span class="second">{{second}}s后重新获取</span>
            </template>
          </van-field>
          <van-field v-model="code" type="number" name="code" label="验证码" maxlength="6" placeholder="请输入验证码"
            :rules="[{ required: true, message: '请输入验证码' }]" />
          <div class="line"></div>
          <van-field v-model="company_name" name="company_name" label="公司名称" placeholder="请输入公司名称"
            :rules="[{ required: true, message: '请输入公司名称' }]" />
          <van-field readonly clickable name="position" :value="position" label="您的职务" placeholder="请选择您的职务"
            @click="showPicker = true" :rules="[{ required: true, message: '请选择您的职务' }]" />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="postlist" @confirm="onConfirm" @cancel="showPicker = false" />
          </van-popup>
          <van-field v-model="password" type="password" name="password" right-icon="eye-o" v-if="!showword"
            @click-right-icon="eyeFun" label="账号密码" placeholder="请设置您的登录密码"
            :rules="[{ required: true, message: '请设置您的登录密码' }]" />
          <van-field v-model="password" type="number" name="password" right-icon="eye" v-if="showword"
            @click-right-icon="eyeFun" label="账号密码" placeholder="请设置您的登录密码"
            :rules="[{ required: true, message: '请设置您的登录密码' }]" />
          <div style="margin: 16px;">
            <van-button block type="info" native-type="submit">注册</van-button>
          </div>
          <wx-open-launch-weapp v-if="isWeixin" id="launch-btns" username="gh_2301fb533b94" path="">
            <script type="text/wxtag-template">
              <style>.btn {display:inline-block;width:100%;text-align:center;color:#0079FF;font-size:14px;padding-bottom:16px;}</style> <span class="btn">已有账号，去试用 ></span>
            </script>
          </wx-open-launch-weapp>
          <span v-else class="btn" @click="linkmini">已有账号，去试用 ></span>
        </van-form>
        <div class="line"></div>
        <div class="videoboxs">
          <p>注册完成如何绑定账号试用</p>
          <video id="video" class="video-js vjs-default-skin" controls preload="none" x5-playsinline=""
            webkit-playsinline="" playsinline=""
            poster="https://xnr-file.oss-cn-beijing.aliyuncs.com/xnd_wx/regiser_poster.jpg" x-webkit-airplay="allow"
            @click="play">
            <source
              src="http://1257289442.vod2.myqcloud.com/5d9018cbvodgzp1257289442/e35b9c883701925920979910316/FaQi2WqYSbcA.mp4">
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import 'video.js/dist/video-js.css'
  import videojs from 'video.js'
  import 'videojs-contrib-hls'
  import {
    Form
  } from 'vant';
  import {
    Field
  } from 'vant';
  Vue.use(Form);
  Vue.use(Field);
  import {
    Toast
  } from 'vant';
  Vue.use(Toast);
  import {
    EnterpriseRegister,
    SendMsg,
    UserRegisterStatistics
  } from '@/api/api'
  export default {
    name: 'Index',
    components: {},
    data() {
      return {
        name: '', //姓名
        tel: '', //手机号
        code: '', //验证码
        company_name: '', //公司名称
        position: '', //职务
        password: '', //账号密码
        postlist: ['总经理', '市场负责人', '运营负责人', '销售负责人', 'IT负责人', '其他职务'], //职务类别
        showPicker: false, //职务选择器
        codeTx: '获取验证码',
        pattern: /^1[3-9]\d{9}$/, //手机号正则
        showword: false, //是否查看密码
        Player: '', // 视频播放器实例
        second: 59,
        verification: true,
        flag: false,
        isWeixin: true, //判断是否微信环境
        openlink: 'weixin://dl/business/?t=6eqvGiQ90Ah', //非微信环境下跳转
        videoplayer: false,
        user_id: '',
      }
    },
    mounted() {
      // 调用方式
      var urlParams = this.GetRequest(location.search);
      if (urlParams["videoplayer"]) {
        this.videoplayer = urlParams["videoplayer"];
      }
      if (urlParams["user_id"]) {
        this.user_id = urlParams["user_id"];
      }
      this.init();
      var ua = navigator.userAgent.toLowerCase()
      var isWXWork = ua.match(/wxwork/i) == 'wxwork'
      this.isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger';
      if (this.isWeixin) {
        this.linkmini();
      }

    },
    methods: {
      GetRequest(url) {
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
          var str = url.substr(1);
          var strs = str.split("&");
          for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
          }
        }
        return theRequest;
      },
      init() {
        this.Player = videojs('video', {
          autoplay: false, //这个说是自动播放，但是本人使用无效
          controls: true,
        }, function() {})
      },
      //选择职务
      onConfirm(value) {
        this.position = value;
        this.showPicker = false;
      },
      play() {
        this.Player.play()
      },
      sendCode() {
        if (this.tel.length == 11 && this.pattern.test(this.tel)) {
          this.SendMsg({
            phone: this.tel,
            scene_value: 1013
          })
        } else {
          Toast.fail('手机号格式错误');
        }

      },
      //注册
      onSubmit(values) {
        if (!this.flag) {
          this.flag = true;
          localStorage.removeItem('account');
          localStorage.removeItem('app_url');
          var data = {
            name: values.name,
            phone: values.pattern,
            register_code: values.code,
            company_name: values.company_name,
            position: values.position,
            register_password: values.password,
            register_type: 1,
            terrace_type: 1
          }
          this.EnterpriseRegister(data);
          clearInterval(this.timer)
          this.second = 59;
          this.verification = true;
          this.codeTx = "获取验证码"
        }
      },
      //查看密码
      eyeFun() {
        this.showword = !this.showword;
      },
      // 用户账号密码注册
      async EnterpriseRegister(data) {
        let [res, err] = await EnterpriseRegister(data)
        this.flag = false;
        if (err) {
          console.log(err, 'err')
          return
        }
        if (this.videoplayer && this.user_id != '') {
          this.UserRegisterStatistics({
            user_id: this.user_id
          })
        }
        localStorage.setItem('account', res.data.account)
        localStorage.setItem('app_url', res.data.app_url)
        this.$router.push({
          name: 'Success',
          query: {
            muser_id: res.muser_id,
            openlink: res.data.skip_url,
          }
        })
      },
      // 发送验证码
      async SendMsg(data) {
        var that = this;
        let [res, err] = await SendMsg(data)
        if (err) {
          console.log(err, 'err')
          return
        }
        that.verification = false;
        that.timer = setInterval(function() {
          that.second = that.second - 1;
          if (that.second == 0) {
            clearInterval(that.timer)
            that.second = 59;
            that.verification = true;
            that.codeTx = "重新获取验证码"
          }
        }, 1000)
      },
      //注册成功统计（仅限宣传视频跳转过去请求）
      async UserRegisterStatistics(data) {
        let [res, err] = await UserRegisterStatistics(data)
        if (err) {
          console.log(err, 'err')
          return
        }
      },
      linkmini() {
        var that = this;

        function docReady(fn) {
          if (document.readyState === 'complete' || document.readyState === 'interactive') {
            fn()
          } else {
            document.addEventListener('DOMContentLoaded', fn);
          }
        }
        docReady(async function() {
          var isMobile = false
          var isDesktop = false
          if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)) {
            isMobile = true
          } else {
            isDesktop = true
          }
          if (isMobile) {
            if (that.isWeixin) {
              const apiurl = 'https://xndapplet.xinnongrenxueshe.cn/v1/token_version/GetJsApiTicket'
              $.ajax({
                //请求方式
                type: 'POST',
                url: apiurl,
                dataType: 'json',
                data: {
                  url: window.location.href.split('#')[0]
                },
                success: function(res) {
                  wxSetConfig(res)
                },
                error: function(jqXHR) {}
              });

              function wxSetConfig(config) {
                wx.config({
                  debug: false,
                  appId: config.appId,
                  timestamp: config.timestamp,
                  nonceStr: config.noncestr,
                  signature: config.signature,
                  jsApiList: ['checkJsApi', 'onMenuShareTimeline'],
                  openTagList: ['wx-open-launch-weapp']
                });
              }

              var btn = document.getElementById('launch-btns');
              btn.addEventListener('launch', function(e) {
                console.log('success');
              });
              btn.addEventListener('error', function(e) {
                console.log('fail', e.detail);
              });

              wx.config({
                // debug: true, // 调试时可开启
                appId: 'wx93ed1efd36df9289', //
                timestamp: 0, // 必填，填任意数字即可
                nonceStr: 'nonceStr', // 必填，填任意非空字符串即可
                signature: 'signature', // 必填，填任意非空字符串即可
                jsApiList: ['chooseImage'], // 必填，随意一个接口即可
                openTagList: ['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
              })
            } else {
              //const apiurls = 'http://xndapplet.xinnongrenxueshe.net/v1/token_version/GetAppScheme'; //测试
              const apiurls = 'https://xndapplet.xinnongrenxueshe.cn/v1/token_version/GetAppScheme'; //正式
              $.ajax({
                //请求方式
                type: 'GET',
                url: apiurls,
                dataType: 'json',
                data: {},
                success: function(res) {
                  window.location.href = res.openlink;
                },
                error: function(jqXHR) {}
              });

              function wxSetConfig(config) {
                wx.config({
                  debug: false,
                  appId: config.appid,
                  timestamp: config.timestamp,
                  nonceStr: config.nonceStr,
                  signature: config.signature,
                  jsApiList: config.jsApiList,
                  openTagList: ['wx-open-launch-weapp']
                });
                var btn = document.getElementById('launch-btns');
                btn.addEventListener('launch', function(e) {
                  console.log('success');
                });
                btn.addEventListener('error', function(e) {
                  console.log('fail', e.detail);
                });
              }
            }
          } else if (isDesktop) {
            console.log(isDesktop)
            // 在 pc 上则给提示引导到手机端打开
            Toast.fail('请在手机端打开');
          }
        })

      },
    }
  }
</script>
<style>
  html,
  body,
  #app {
    height: 100vh;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .container {
    width: 100%;
    min-height: 100%;
    background: #fff;
    display: flex;
  }

  .content {
    width: 100%;
    min-height: 100%;
    background: #fff;
    position: relative;
  }

  .bg {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .logobox {
    width: 100%;
    /* height: 153.5px; */
    margin-bottom: 3vh;
    position: relative;
    top: 0;
    left: 0;
  }

  .logo {
    width: 42.6%;
    margin-top: 2vh;
  }

  .title {
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    padding: 0;
    margin: 0;
  }

  .box {
    width: 100%;
    height: 80vh;
    background: #fff;
    border-radius: 12px;
    /* margin-top: -2vh; */
    position: relative;
  }

  .tx {
    font-size: 16px;
    font-weight: bold;
    padding: 0;
    margin: 0;
    text-align: left;
    padding-top: 20px;
    padding-left: 16px;
    margin-bottom: 8px;
  }

  .codetx {
    display: inline-block;
    padding: 0 12px;
    ;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border-radius: 20px;
    border: 1px solid #0079FF;
    font-size: 14px;
    font-weight: 600;
    color: #0079FF;
  }

  .line {
    width: 100%;
    height: 8px;
    background: #F3F4F6;
  }

  .videoboxs {
    padding: 20px 16px;
    font-size: 18px;
    color: #222222;
    text-align: left;
  }

  .videoboxs p {
    padding: 0;
    margin: 0;
    margin-bottom: 12px;
  }

  #video {
    width: 100%;
    height: 193px;
    margin-bottom: 20px;
  }

  .vjs-big-play-button {
    left: 50% !important;
    top: 50% !important;
    margin-top: -1em;
    margin-left: -1em;
  }

  .video-js .vjs-big-play-button {
    border: unset !important;
    background-color: unset !important;
  }

  .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
    width: 52px;
    height: 52px;
    font-size: 30px;
    background: rgba(0, 0, 0, .5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .second {
    display: inline-block;
    width: 118px;
    height: 32px;
    background: #F3F4F6;
    border-radius: 19px;
    font-size: 14px;
    text-align: center;
    line-height: 32px;
    font-weight: 400;
    color: #222222;
  }

  .btn {
    display: inline-block;
    text-align: center;
    color: #0079FF;
    font-size: 14px;
    padding: 0 0 16px 0;
  }

  #launch-btns {
    width: 100%;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/view/login.vue